import api from "../../../../../../utils/api"

export const loadCaseData = async ({caseId}) => {
    const {data} = await api.get('/report-cases/'+caseId)
    return data.reportCases[0]
}